import { useTranslation } from 'react-i18next';
import { faCheckCircle, faRotateRight } from '@fortawesome/pro-light-svg-icons';
import ActionButton from 'components/ui/ActionButton';
import styled from 'styled-components';

type CompleteReturnProps = {
    onComplete: () => void;
    disabled: boolean;
    isLoading?: boolean;
    isCreditError?: boolean;
};

const CompleteReturn = ({ onComplete, disabled, isLoading, isCreditError }: CompleteReturnProps) => {
    const { t } = useTranslation();
    return (
        <PrimaryStatusBtn
            label={t('completeReturn')}
            onClick={onComplete}
            disabled={disabled}
            isLoading={isLoading}
            icon={isCreditError ? faRotateRight : faCheckCircle}
            fullWidth
            rounded
        />
    );
};

export default CompleteReturn;

const PrimaryStatusBtn = styled(ActionButton)<{ disabled: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 1rem;
    border: none;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;

    background: #6fb48f !important;
    color: ${({ theme }) => theme.colors.fillWhite} !important;

    &:disabled {
        background: ${({ theme }) => theme.colors.disabled} !important;
        cursor: text;
    }

    // no hover effect when disabled
    &:not(:disabled):hover {
        opacity: 0.7;
    }
`;
